import { cn } from 'cn';
import { type ReactNode } from 'react';

import { ParagraphWrapper } from '~/ui/atoms/ParagraphWrapper';

type P = {
  readonly callToAction?: ReactNode;
  readonly illustration?: ReactNode;
  readonly message: string | string[];
  readonly title: string;
} & ComponentStyling;

export const ErrorPage = ({
  callToAction,
  className,
  illustration,
  message,
  style,
  title,
}: P) => (
  <div
    className={cn(
      // Inherits the min-height of #root so the stand-alone page fills the viewport.
      'flex size-full min-h-[inherit] flex-col items-center justify-center',
      className,
    )}
    style={style}
  >
    <div className="flex flex-col items-center gap-4">
      {title ? (
        <h1 className="text-tigaSemantic-error line-clamp-1 text-center text-4xl tracking-tight text-balance">
          {title}
        </h1>
      ) : null}
      <ParagraphWrapper
        className="text-tigaSemantic-error"
        paragraphs={message}
      />
      {callToAction}
      {illustration}
    </div>
  </div>
);
